<template>
  <div id="app">
    <app-header
      v-if="showNavigation"
      :active="activeMenu"
      :user-name="userName"
      :role="userRole"
      @user-action="handleUserAction"
    />
    <div v-show="globalLoading" class="global-loading-bar"></div>
    <div
      class="app-main"
      role="main"
      :class="{ 'with-header': showNavigation }"
    >
      <router-view />
    </div>

    <!-- 个人资料对话框 -->
    <profile-dialog :visible.sync="profileDialogVisible" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppHeader from "@/components/layout/AppHeader.vue";
import ProfileDialog from "@/components/common/ProfileDialog.vue";

export default {
  name: "App",
  components: { 
    AppHeader,
    ProfileDialog,
  },
  data() {
    return { 
      activeMenu: "/home", 
      globalLoading: false,
      profileDialogVisible: false,
    };
  },
  computed: {
    ...mapGetters("user", ["userDisplayName", "userRole"]),

    showNavigation() {
      // 登录页面不显示导航栏
      return this.$route.path !== "/login";
    },

    userName() {
      return this.userDisplayName || "家长";
    },
  },
  watch: {
    $route(to) {
      this.activeMenu = to.path;
    },
  },
  mounted() {
    // 初始化用户认证状态
    this.$store.dispatch("user/initializeAuth");
    this.activeMenu = this.$route.path;
    // 简易全局loading示例：监听路由
    this.$router.beforeEach((to, from, next) => {
      this.globalLoading = true;
      next();
    });
    this.$router.afterEach(() => {
      setTimeout(() => (this.globalLoading = false), 200);
    });
  },
  methods: {
    ...mapActions("user", ["logout"]),

    /**
     * 处理菜单选择
     */
    /**
     * 处理用户操作
     */
    handleUserAction(command) {
      switch (command) {
        case "profile":
          this.profileDialogVisible = true;
          break;
        case "settings":
          this.$message.info("设置功能开发中...");
          break;
        case "logout":
          this.handleLogout();
          break;
      }
    },

    /**
     * 退出登录
     */
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          await this.logout();
          // 跳转到登录页
          this.$router.push("/login");
          this.$message.success("已退出登录");
        } catch (error) {
          console.error("退出登录错误:", error);
          this.$message.error("退出登录失败");
        }
      });
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  background-color: #f5f7fa;
}

/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #f5f7fa;
}

/* 顶部导航栏 */
/* 头部已抽离到组件 */

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 60px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 18px;
  color: #409eff;
}

.logo i {
  font-size: 24px;
}

.logo-text {
  color: #303133;
}

.nav-menu {
  flex: 1;
  margin: 0 40px;
  border-bottom: none;
}

.nav-menu .el-menu-item {
  height: 60px;
  line-height: 60px;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;
}

.nav-menu .el-menu-item:hover {
  background-color: #f5f7fa;
  color: #409eff;
}

.nav-menu .el-menu-item.is-active {
  border-bottom-color: #409eff;
  color: #409eff;
  background-color: transparent;
}

.nav-menu .el-menu-item i {
  margin-right: 6px;
  font-size: 16px;
}

.header-actions {
  display: flex;
  align-items: center;
}

.user-btn {
  padding: 8px 16px;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
}

.user-btn:hover {
  color: #409eff;
  background-color: #f5f7fa;
}

/* 主要内容区域 */
.app-main {
  min-height: 100vh;
}

.app-main.with-header {
  min-height: calc(100vh - 60px);
}

.global-loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #409eff, #67c23a, #e6a23c);
  animation: loadingBar 1s linear infinite;
  z-index: 2000;
}
@keyframes loadingBar {
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}

/* Element UI 样式覆盖 */
.el-button {
  border-radius: 6px;
}

.el-card {
  border-radius: 8px;
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-input__inner {
  border-radius: 6px;
}

.el-table {
  border-radius: 8px;
  overflow: hidden;
}

.el-table th {
  background-color: #fafafa;
  font-weight: 600;
}

.el-dialog {
  border-radius: 8px;
}

.el-dropdown-menu {
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 响应式设计 */
/* 响应式处理已移动到 AppHeader 组件 */
</style>
